@if (isMobileOpen()) {
<div
    (click)="toggleMobile()"
    class="fixed inset-0 bg-surface-900/40 dark:bg-surface-900/60 backdrop-blur-sm z-40 md:hidden transition-opacity cursor-pointer"
    aria-hidden="true">
</div>
}

<div [ngClass]="{
        'translate-x-0': isMobileOpen(),
        '-translate-x-full md:translate-x-0': !isMobileOpen()
    }"
    [className]="(isCollapsed() ? 'md:w-20' : 'md:w-64') + ' w-64 fixed md:relative z-50 h-screen bg-surface-0 dark:bg-surface-900 border-r border-surface-200 dark:border-surface-800 flex flex-col transition-transform duration-300 flex-shrink-0 shadow-2xl md:shadow-none'"
    role="navigation"
    aria-label="Main navigation">

    <div class="h-16 flex items-center px-6 border-b border-surface-200 dark:border-surface-800 flex-shrink-0 relative">
        @if (isCollapsed()) {
            <div class="w-8 h-8 rounded-lg flex items-center justify-center mx-auto transition-colors duration-300 hidden md:flex bg-primary p-1">
                <img src="assets/logo.png" alt="Arrow HR" class="h-full w-full object-contain" />
            </div>
            <button (click)="onToggleCollapse()"
                class="absolute -right-3 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full hidden md:flex items-center justify-center text-white hover:brightness-110 transition-all shadow-md z-10 border-none cursor-pointer"
                [style.backgroundColor]="'var(--p-primary-600)'"
                aria-label="Expand sidebar">
                <i class="pi pi-chevron-right text-xs"></i>
            </button>
        } @else {
            <div class="flex items-center gap-2 flex-1">
                <div class="w-8 h-8 rounded-lg flex items-center justify-center transition-colors duration-300 bg-primary p-1">
                    <img src="assets/logo.png" alt="Arrow HR" class="h-full w-full object-contain" />
                </div>
                <span class="text-lg font-bold text-text-main tracking-tight">Arrow HR</span>
            </div>
            <button (click)="onToggleCollapse()"
                class="w-8 h-8 hidden md:flex items-center justify-center rounded-lg transition-colors border-none cursor-pointer"
                [style.color]="'var(--p-primary-600)'"
                [style.backgroundColor]="'var(--p-primary-50)'"
                pRipple
                aria-label="Collapse sidebar">
                <i class="pi pi-chevron-left text-sm font-bold"></i>
            </button>
            <button (click)="toggleMobile()"
                class="w-8 h-8 flex md:hidden items-center justify-center rounded-lg text-text-muted hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors border-none cursor-pointer"
                aria-label="Close navigation">
                <i class="pi pi-times text-sm"></i>
            </button>
        }
    </div>

    <nav class="flex-1 py-4 px-3 custom-scrollbar"
        [ngClass]="isCollapsed() ? 'overflow-visible' : 'overflow-y-auto overflow-x-hidden'"
        aria-label="Site pages">
        <ul class="space-y-1 list-none p-0 m-0" role="list">
            @for (item of visibleMenuItems(); track item.label) {
                <ng-container *ngTemplateOutlet="menuItemTpl; context: { $implicit: item, level: 0 }"></ng-container>
            }
        </ul>
    </nav>
</div>

<ng-template #menuItemTpl let-item let-level="level">
    <li class="relative group" role="listitem">

        <div [pTooltip]="isCollapsed() ? item.label : ''" tooltipPosition="right" [showDelay]="400">

            @if (item.path && !item.children?.length) {
                <a [routerLink]="item.path"
                   (click)="toggleMobile()"
                   routerLinkActive #rla="routerLinkActive"
                   [routerLinkActiveOptions]="{ exact: true }"
                   class="flex items-center rounded-lg no-underline cursor-pointer border-none select-none transition-all duration-200"
                   [ngClass]="[
                     isCollapsed() ? 'justify-center p-3' : 'gap-3 p-2.5',
                     rla.isActive
                       ? 'bg-primary-50 dark:bg-primary-500/10 text-primary-600 dark:text-primary-400 font-semibold'
                       : 'text-text-main hover:bg-primary-50 dark:hover:bg-primary-500/10 hover:text-primary-600 dark:hover:text-primary-400'
                   ]"
                   [style.padding-left.px]="isCollapsed() ? null : (10 + level * 20)"
                   pRipple>

                    <i [class]="item.icon + ' text-center flex-shrink-0 transition-all duration-200 ' + (isCollapsed() ? 'text-xl' : 'w-5 ' + (level >= 2 ? 'text-xs' : 'text-sm'))"></i>
                    @if (!isCollapsed()) {
                        <span class="flex-1 truncate min-w-0">{{ item.label }}</span>
                    }
                </a>
            } @else {
                <button (click)="isCollapsed() ? null : toggleExpand(item)"
                    class="flex items-center rounded-lg no-underline cursor-pointer border-none select-none transition-all duration-200 w-full"
                    [ngClass]="{
                        'bg-primary-50 dark:bg-primary-500/10 text-primary-600 dark:text-primary-400 font-semibold': item.expanded && item.children && !isCollapsed(),
                        'text-text-main hover:bg-primary-50 dark:hover:bg-primary-500/10 hover:text-primary-600 dark:hover:text-primary-400': !(item.expanded && item.children && !isCollapsed()),
                        'justify-center p-3': isCollapsed(),
                        'gap-3 p-2.5': !isCollapsed()
                    }"
                    [style.padding-left.px]="isCollapsed() ? null : (10 + level * 20)"
                    [attr.aria-expanded]="!isCollapsed() ? (item.expanded ? 'true' : 'false') : null"
                    pRipple>

                    <i [class]="item.icon + ' text-center flex-shrink-0 transition-all duration-200 ' + (isCollapsed() ? 'text-xl' : 'w-5 ' + (level >= 2 ? 'text-xs' : 'text-sm'))"></i>

                    @if (!isCollapsed()) {
                        <span class="flex-1 text-left truncate min-w-0">{{ item.label }}</span>
                        @if (item.children) {
                            <i class="pi pi-chevron-down !text-xs transition-transform duration-200" [ngClass]="{ '-rotate-90': !item.expanded }" aria-hidden="true"></i>
                        }
                    }
                </button>
            }
        </div>

        <!-- Collapsed flyout submenu -->
        @if (isCollapsed() && item.children?.length) {
            <div class="hidden group-hover:block absolute left-[100%] top-0 pl-3 w-64 z-[100]"
                role="menu"
                [attr.aria-label]="item.label + ' submenu'">
                <div class="bg-surface-0 dark:bg-surface-900 border border-surface-200 dark:border-surface-800 rounded-xl shadow-2xl py-2 max-h-[80vh] overflow-y-auto">

                    <div class="px-4 py-2 text-xs font-bold text-text-muted uppercase tracking-wider border-b border-surface-100 dark:border-surface-800 mb-1">
                        {{item.label}}
                    </div>

                    @for (child of item.children; track child.label) {
                        @if (!child.children) {
                            <a [routerLink]="child.path"
                                (click)="toggleMobile()"
                                routerLinkActive #rlaChild="routerLinkActive"
                                class="flex items-center gap-3 px-4 py-2.5 text-sm transition-colors no-underline"
                                [ngClass]="rlaChild.isActive
                                  ? 'bg-primary-50 dark:bg-primary-500/10 text-primary-600 dark:text-primary-400 font-semibold'
                                  : 'text-text-main hover:bg-primary-50 dark:hover:bg-primary-500/10 hover:text-primary-600 dark:hover:text-primary-400'"
                                role="menuitem">
                                <i [class]="child.icon + ' text-sm'"></i>
                                <span>{{ child.label }}</span>
                            </a>
                        }

                        @if (child.children) {
                            <div class="px-4 py-2">
                                <div class="flex items-center gap-2 text-sm font-semibold text-text-main mb-2">
                                    <i [class]="child.icon + ' text-sm'"></i>
                                    <span>{{child.label}}</span>
                                </div>
                                <div class="ml-2 pl-3 border-l border-surface-200 dark:border-surface-700 flex flex-col gap-1">
                                    @for (sub of child.children; track sub.label) {
                                        <a [routerLink]="sub.path"
                                            (click)="toggleMobile()"
                                            routerLinkActive #rlaSub="routerLinkActive"
                                            class="py-1.5 px-2 text-sm transition-colors no-underline flex items-center gap-2"
                                            [ngClass]="rlaSub.isActive
                                              ? 'bg-primary-50 dark:bg-primary-500/10 text-primary-600 dark:text-primary-400 font-semibold rounded-md'
                                              : 'text-text-main hover:text-primary-600 dark:hover:text-primary-400'"
                                            role="menuitem">
                                            <i [class]="sub.icon + ' text-xs'"></i>
                                            <span>{{sub.label}}</span>
                                        </a>
                                    }
                                </div>
                            </div>
                        }
                    }
                </div>
            </div>
        }

        @if (!isCollapsed() && item.children && item.expanded) {
            <ul class="space-y-1 list-none p-0 m-0 mt-1" role="list">
                @for (child of item.children; track child.label) {
                    <ng-container *ngTemplateOutlet="menuItemTpl; context: { $implicit: child, level: level + 1 }"></ng-container>
                }
            </ul>
        }

    </li>
</ng-template>
